export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS';

export function loadProjects(data) {
  const normalizedProjects = {};
  const projectsArray = Array.isArray(data) ? data : Object.values(data);

  projectsArray.forEach((project) => {
    if (project && project.project_id) {
      normalizedProjects[project.project_id] = {
        ...project,
        latitude: project.latitude ? Number(project.latitude) : null,
        longitude: project.longitude ? Number(project.longitude) : null,
        _updated: Date.now(),
      };
    }
  });

  return {
    type: LOAD_PROJECTS,
    data: normalizedProjects,
    meta: { timestamp: Date.now() },
  };
}

export function clearProjects() {
  return { type:CLEAR_PROJECTS }
}
